var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionScaleEditor", {
        attrs: { viewModel: _vm.criterionScaleEditor },
        on: {
          "assign-custom-scale": _vm.handleAssignCustomScaleMeasurementCommand,
        },
      }),
      _vm._v(" "),
      _c("DiscreteScaleEditor", {
        attrs: { viewModel: _vm.discreteScaleEditor },
        on: { "create-scale": _vm.handleCreateWorkspaceScaleCommand },
      }),
      _vm._v(" "),
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: { "numeric-attribute-created": _vm.numericAttributeCreated },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.Initialized
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Initialized
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Goal: " + _vm._s(_vm.rm.GoalName))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ActivePage: "criteria-scales",
                      ScoringEnabled: _vm.rm.ScoringEnabled,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "nav",
                    {
                      staticClass:
                        "navbar navbar-light navbar-expand-md bg-light",
                      attrs: { role: "navigation" },
                    },
                    [
                      _c("form", { staticClass: "form-inline mr-2" }, [
                        _c("div", { staticClass: "btn-group" }, [
                          _vm.NoneCriteriaSelected
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { type: "button" },
                                  on: { click: _vm.selectAll },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-square",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.AnyCriteriaSelected && !_vm.AllCriteriaSelected
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { type: "button" },
                                  on: { click: _vm.unselectAll },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-square-minus",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.AllCriteriaSelected
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { type: "button" },
                                  on: { click: _vm.unselectAll },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-square-check",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("button", {
                            staticClass:
                              "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.selectAll },
                              },
                              [_vm._v("All")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.unselectAll },
                              },
                              [_vm._v("None")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.inverseSelection },
                              },
                              [_vm._v("Inverse")]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("form", { staticClass: "form-inline mr-auto" }, [
                        _c("div", { staticClass: "btn-group" }, [
                          _vm.AnyCriteriaSelected
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-primary btn-sm dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [_vm._v("Set measurement")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("Survey based"),
                            ]),
                            _vm._v(" "),
                            _vm.ScalesTemplates == null
                              ? _c("div", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin",
                                  }),
                                  _vm._v(
                                    " Loading scales\n                            "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _vm.ScalesTemplates.length === 0
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "text-muted px-4 mb-1 font-italic d-block",
                                          },
                                          [
                                            _vm._v(
                                              "You don't have any scales templates yet."
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.ScalesTemplates, function (st) {
                                      return _c(
                                        "a",
                                        {
                                          key: st.Id,
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleBulkAssignScaleTemplateMeasurementCommandV1(
                                                st
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(st.Name))]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click:
                                    _vm.handleBulkAssignPairwiseMeasurementCommand,
                                },
                              },
                              [_vm._v("Pairwise comparisons")]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "form-inline my-2 my-lg-0",
                          attrs: { role: "search" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.SearchPhrase,
                                expression: "SearchPhrase",
                              },
                            ],
                            staticClass: "form-control form-control-sm mr-sm-2",
                            attrs: { type: "search", placeholder: "Search" },
                            domProps: { value: _vm.SearchPhrase },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.SearchPhrase = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-deck" }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v("Survey based  "),
                            _c("small", [
                              _vm._v("("),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showWorkspaceScaleCreator(null)
                                    },
                                  },
                                },
                                [_vm._v("create scale template")]
                              ),
                              _vm._v(")"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              "Collect Data by asking respondents to rate alternatives - ideal for capturing experts' opinions & stakeholders' points of view."
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.SurveyBased, function (c) {
                            return _c(
                              "div",
                              {
                                key: c.CriterionId,
                                staticClass: "tile rounded-0 mx-0 mt-0 mb-3",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-ellipsis fg-color-gray mb-0 mt-1",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: c.IsSelected,
                                          expression: "c.IsSelected",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(c.IsSelected)
                                          ? _vm._i(c.IsSelected, null) > -1
                                          : c.IsSelected,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = c.IsSelected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  c,
                                                  "IsSelected",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  c,
                                                  "IsSelected",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(c, "IsSelected", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { attrs: { title: c.Name } }, [
                                      _vm._v(_vm._s(c.Name)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(c.Path)),
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                c.Loading
                                  ? _c("p", { staticClass: "m-0" }, [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !c.Loading
                                  ? _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [_vm._v(_vm._s(c.MeasurementLabel))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-menu",
                                          staticStyle: {
                                            "max-height": "300px",
                                            "overflow-y": "auto",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "container-fluid" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "h6",
                                                        {
                                                          staticClass:
                                                            "dropdown-header",
                                                        },
                                                        [_vm._v("Survey based")]
                                                      ),
                                                      _vm._v(" "),
                                                      c.HasScale
                                                        ? _c("div", [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showCriterionScaleEditor(
                                                                        c
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Edit scale"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showWorkspaceScaleCreator(
                                                                        c
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Save as scale template"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleAssignPairwiseMeasurementCommand(
                                                                        c
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Pairwise comparisons"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", {
                                                              staticClass:
                                                                "dropdown-divider",
                                                            }),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !c.HasScale
                                                        ? _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showCriterionScaleEditor(
                                                                      c
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Custom scale"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.ScalesTemplates
                                                        .length === 0
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted px-4 mb-1 font-italic d-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    You don't have any scales templates yet.\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.ScalesTemplates,
                                                        function (st) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: st.DiscreteScaleId,
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAssignScaleTemplateMeasurementCommandV1(
                                                                      c,
                                                                      st
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    st.Name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "h6",
                                                        {
                                                          staticClass:
                                                            "dropdown-header",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Attribute based"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.Attributes.length ===
                                                      0
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted px-4 mb-1 font-italic d-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "You don't have any attributes yet."
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.Attributes,
                                                        function (attr) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: attr.Id,
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAssignAttributeMeasurementCommand(
                                                                      c,
                                                                      attr.Id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    attr.Name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v("Attribute based "),
                            _c("small", [
                              _vm._v("("),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  on: { click: _vm.showAttributeCreator },
                                },
                                [_vm._v("create attribute")]
                              ),
                              _vm._v(")"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              "Collect Data via a Form - ideal for using the output from existing models, hard data, or a subjective rating from a single source."
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.AttributeBased, function (c) {
                            return _c(
                              "div",
                              {
                                key: c.CriterionId,
                                staticClass: "tile rounded-0 mx-0 mt-0 mb-3",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-ellipsis fg-color-gray mb-0 mt-1",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: c.IsSelected,
                                          expression: "c.IsSelected",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(c.IsSelected)
                                          ? _vm._i(c.IsSelected, null) > -1
                                          : c.IsSelected,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = c.IsSelected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  c,
                                                  "IsSelected",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  c,
                                                  "IsSelected",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(c, "IsSelected", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { attrs: { title: c.Name } }, [
                                      _vm._v(_vm._s(c.Name)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(c.Path)),
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                c.Loading
                                  ? _c("p", { staticClass: "m-0" }, [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !c.Loading
                                  ? _c("div", { staticClass: "dropdown" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: { "data-toggle": "dropdown" },
                                        },
                                        [_vm._v(_vm._s(c.MeasurementLabel))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-menu",
                                          staticStyle: {
                                            "max-height": "300px",
                                            "overflow-y": "auto",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "container-fluid" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "h6",
                                                        {
                                                          staticClass:
                                                            "dropdown-header",
                                                        },
                                                        [_vm._v("Survey based")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showCriterionScaleEditor(
                                                                c
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Custom scale")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.ScalesTemplates
                                                        .length === 0
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted px-4 mb-1 font-italic d-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    You don't have any scales templates yet.\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.ScalesTemplates,
                                                        function (st) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: st.DiscreteScaleId,
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAssignScaleTemplateMeasurementCommandV1(
                                                                      c,
                                                                      st
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    st.Name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "dropdown-divider",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "dropdown-item",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleAssignPairwiseMeasurementCommand(
                                                                c
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Pairwise comparisons"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "h6",
                                                        {
                                                          staticClass:
                                                            "dropdown-header",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Attribute based"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.Attributes.length ===
                                                      0
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted px-4 mb-1 font-italic d-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "You don't have any attributes yet."
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.Attributes,
                                                        function (attr) {
                                                          return _c(
                                                            "a",
                                                            {
                                                              key: attr.Id,
                                                              staticClass:
                                                                "dropdown-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleAssignAttributeMeasurementCommand(
                                                                      c,
                                                                      attr.Id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    attr.Name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._m(1),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary float-right",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/build-criteria",
          title: "User guide: Build criteria",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "alert alert-danger" }, [
      _c("p", [
        _vm._v(
          "\n                                NEGATIVE numbers will be rounded to zero in any calculations.\n                                Remember, you could use calculated attributes to transform your values so they are all positive.\n                            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }